import React, { useEffect, useState } from 'react';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Checkbox, Col, Input, InputNumber, Modal, Row, Table, Tooltip } from 'antd';
import Title from 'antd/es/typography/Title';
import { KeyResultSymbol, ObjectiveSymbol } from 'app/config/constants';
import { getCurrentPlanPeriodOpen } from 'app/entities/common/common.reducer';
import { FuncTypes, funcTypeToString } from 'app/shared/model/enum/func-type.enum';
import { formatPoint, percent } from 'app/shared/util/percent';
import * as _ from 'lodash';
import { getCurrentStatusProcess, getEntitiesEvaluate, getOtherComment, resetApprovalEntity, saveDraft } from './category-evaluation.reducer';
import { columnsEvaluation } from './config';
import CheckConfirmCompleteEvaluation from './confirm-complete/check/confirm-complete';
import EvaConfirmCompleteEvaluation from './confirm-complete/evaluate/confirm-complete';
import OtherCommentComponent from './other-comment';
import { ReportKr as ReportYear } from 'app/entities/kr/form/report/year/reportKr';
import { setFilterOrgCheckIn } from 'app/entities/filters/filters.reducer';
import { StatusType } from 'app/shared/model/enum/status.enum';

type IEvaluationObjectiveKRProps = {
    isOpen: boolean;
    onClose: (isReload?: boolean) => void;
    documentId?: string;
    accountTableId: string;
    accountableName: string;
    isFinished?: boolean;
    planPeriodId?: string;
};

const { Search } = Input;

export const EvaluationObjectiveKRComponent = ({ isOpen, onClose, documentId, accountTableId, accountableName, isFinished, planPeriodId }: IEvaluationObjectiveKRProps) => {
    const dispatch = useAppDispatch();
    const treeData = useAppSelector(state => state.categoryEvaluation.entityEvaluates);
    const loading = useAppSelector(state => state.categoryEvaluation.loading);
    const updating = useAppSelector(state => state.categoryEvaluation.updating);
    const currentStatusProcess = useAppSelector(state => state.categoryEvaluation.entity);
    const otherComment = useAppSelector(state => state.categoryEvaluation.otherComment);
    const account = useAppSelector(state => state.authentication.account);
    const currentPlanPeriod = useAppSelector(state => state.common.currentPlanPeriod);
    const filters = useAppSelector(state => state.filters.orgCheckIn);

    // innit state
    const [KRComments, setKRComments] = useState([])
    const [isLoadingComment, setLoadingComment] = useState(false);
    const [isOpenModalCheckConfirmComplete, setOpenModalCheckConfirmComplete] = useState(false);
    const [isOpenModalEvaConfirmComplete, setOpenModalEvaConfirmComplete] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    const [expandedRowKeys, setExpandedRowKeys] = useState([]);
    const [isOpenModalOtherComment, setOpenModalOtherComment] = useState(false);
    const [initDocumentId, setDocumentId] = useState(null);
    const [isOpenModalReportKrYear, setOpenModalReportKrYear] = useState(false);
    const [krBaseSelected, setKrBaseSelected] = useState(null);

    useEffect(() => {
        dispatch(getCurrentPlanPeriodOpen());
        handleFetCurrentStatusProcess();
    }, [])

    useEffect(() => {
        if (currentPlanPeriod?.value)
            handleGetTreeOrg();
    }, [currentPlanPeriod])

    useEffect(() => {
        if (KRComments.length > 0) {
            // Tính tổng lại cho các node cha
            const updatedData = treeData.map((item) => {
                if (item.children) {
                    return {
                        ...item, // Create a new object, spreading the original properties
                        point: calculateTotalAmount(item), // Update the point for the new object
                    };
                }
                return item;
            });
            setDataSource(updatedData);
        }
    }, [KRComments])

    useEffect(() => {
        if (treeData.length > 0) {
            const allRowKeys = getAllRowKeys(treeData);
            setExpandedRowKeys(allRowKeys);
            const krs = getAllChildren(treeData)
            setKRComments(krs.map(x => {
                return {
                    itemId: x.itemId,
                    agree: x.isAgree,
                    comment: x.feedbackContent,
                    contribution: x.contribution,
                    point: formatPoint(x.point),
                }
            }))
        }
    }, [treeData])

    const columnConfig = [...columnsEvaluation, currentStatusProcess && (currentStatusProcess.functionKey === FuncTypes.Check || currentStatusProcess.functionKey === FuncTypes.Appraisal) ?
        {
            title: `${treeData[0]?.processingLevelName} - ${treeData[0]?.processingPerformerName}`,
            width: 300,
            children: [
                {
                    title: 'Ý kiến',
                    key: 'comment',
                    width: 250,
                    align: 'center',
                    render: (record) => _.startsWith(record.itemCode, KeyResultSymbol) &&
                        <Input defaultValue={record?.feedbackContent} disabled={isFinished || !record?.isEdit}
                            onClick={(e) => {
                                e.stopPropagation(); // Stop the event from propagating to the row
                            }}
                            onChange={(e) => {
                                handleChangeInput(record.itemId, e.target.value)
                            }} />
                },
                {
                    key: 'action',
                    width: 60,
                    align: 'center',
                    render: (record) => _.startsWith(record.itemCode, KeyResultSymbol) &&
                        <Tooltip title="Xem ý kiến khác">
                            <FontAwesomeIcon
                                onClick={(event) => {
                                    event.stopPropagation(); // Stop the event from propagating to the row
                                    handleGetOtherComments(record.itemId);
                                }}
                                icon="eye"
                                color='blue'
                            />
                        </Tooltip>
                }
            ]
        }
        :
        {
            title: `${treeData[0]?.processingLevelName} - ${treeData[0]?.processingPerformerName}`,
            width: 300,
            children: [
                {
                    title: 'Đồng ý',
                    key: 'agree',
                    width: 80,
                    align: 'center',
                    render: (record) => _.startsWith(record.itemCode, KeyResultSymbol) &&
                        <Checkbox disabled={isFinished || !record?.isEdit} defaultChecked={record?.isAgree} onClick={(e) => { e.stopPropagation() }} onChange={(e) => {
                            e.stopPropagation(); // Stop the event from propagating to the row
                            handleChangeCheckBox(record, e.target.checked)
                        }} />
                },
                {
                    title: 'Điểm ĐG',
                    key: 'point',
                    width: 180,
                    align: 'center',
                    render: (record) => _.startsWith(record.itemCode, KeyResultSymbol) ?
                        <InputNumber value={_.find(KRComments, o => {
                            return o.itemId === record.itemId;
                        })?.point} disabled={_.find(KRComments, o => {
                            return o.itemId === record.itemId && o.agree;
                        }) || !record?.isEdit} addonAfter="%"
                            onClick={(e) => {
                                e.stopPropagation(); // Stop the event from propagating to the row
                            }}
                            onChange={(e) => {
                                handleChangeInputNumber(record.itemId, e)
                            }} /> :
                        `${formatPoint(record?.point)}%`

                },
                {
                    title: 'Ý kiến',
                    key: 'comment',
                    width: 250,
                    align: 'center',
                    render: (record) => _.startsWith(record.itemCode, KeyResultSymbol) &&
                        <Input disabled={isFinished || !record?.isEdit}
                            defaultValue={record?.feedbackContent}
                            onClick={(e) => {
                                e.stopPropagation(); // Stop the event from propagating to the row
                            }}
                            onChange={(e) => {
                                handleChangeInput(record.itemId, e.target.value)
                            }} />
                },
                {
                    key: 'action',
                    width: 60,
                    align: 'center',
                    render: (record) => _.startsWith(record.itemCode, KeyResultSymbol) &&
                        <Tooltip title="Xem ý kiến khác">
                            <FontAwesomeIcon
                                onClick={(event) => {
                                    event.stopPropagation(); // Stop the event from propagating to the row
                                    handleGetOtherComments(record.itemId);
                                }}
                                icon="eye"
                                color='blue'
                            />
                        </Tooltip>
                }
            ]
        }
    ];

    const handleFetCurrentStatusProcess = () => {
        dispatch(getCurrentStatusProcess({ ownerId: accountTableId, userId: account?.id, planPeriodId: planPeriodId }));
    }

    const getAllRowKeys = (item) => {
        return item.reduce((keys, value, idx) => {
            keys.push(`${value?.itemId}`);

            if (value.children) {
                keys = keys.concat(getAllRowKeys(value.children));
            }

            return keys;
        }, []);
    };

    const getAllChildren = (nodes) => {
        let children = [];
        nodes.forEach(node => {
            children = children.concat(node.children); // Add the current node
        });
        return children;
    };

    // Hàm tính tổng cho mỗi node cha
    const calculateTotalAmount = (node) => {
        // Tổng giá trị của node và các con của nó
        const totalContribution = _.sumBy(node.children, (child: any) => {
            if (child.ratingPoint !== 0)
                return child.contribution
            else if (child.ratingPoint === 0 && child.status !== StatusType.Cancel && child.status !== StatusType.Postponed)
                return child.contribution;
        })
        const childTotal = node.children ? _.sumBy(_.filter(KRComments, o => node.children.map(x => x.itemId).includes(o.itemId)), o => {
            if (o.ratingPoint !== 0)
                return percent(o.point) * o.contribution
            else if (o.ratingPoint === 0 && o.status !== StatusType.Cancel && o.status !== StatusType.Postponed)
                return 0;
        }) : 0;
        return childTotal / totalContribution;
    };

    const handleGetTreeOrg = () => {
        dispatch(getEntitiesEvaluate({ ownerId: account?.id, accountTableId, planPeriodId: planPeriodId ?? currentPlanPeriod?.value }))
    }

    const handleExport = (values) => {
        console.log(values);
    }

    const handleFreeTextSearchQuery = query => {
        // dispatch(setListFilterApprovalLevel({ ...filters, searchText: query }))
    };

    const handleClose = (reload = undefined) => {
        dispatch(resetApprovalEntity())
        onClose(reload);
    };

    const handleChangeCheckBox = (record, agree) => {
        setKRComments(prevState => {
            return prevState.map(item => {
                if (item.itemId === record.itemId) {
                    return { ...item, agree, point: agree ? formatPoint(record.ratingPoint) : 0 };
                }
                return item;
            });
        });
    }

    const handleChangeInputNumber = (recordId, point) => {
        setKRComments(prevState => {
            return prevState.map(item => {
                if (item.itemId === recordId) {
                    return { ...item, point };
                }
                return item;
            });
        });
    }

    const handleChangeInput = (recordId, comment) => {
        setKRComments(prevState => {
            return prevState.map(item => {
                if (item.itemId === recordId) {
                    return { ...item, comment };
                }
                return item;
            });
        });
    }

    const handleMapPayloadSaveDraft = () => {
        const payload = {
            documentId: initDocumentId ?? documentId ?? treeData.length > 0 ? treeData[0]?.documentId : undefined,
            ownerId: accountTableId,
            userId: account?.id,
            evaluateLevelId: treeData.length > 0 ? treeData[0]?.processingLevelId : undefined,
            planPeriodId: planPeriodId || currentPlanPeriod?.value,
            evaluateFeedbackItems: KRComments.map(x => {
                return {
                    itemId: x.itemId,
                    isAgree: x.agree,
                    feedbackContent: x.comment,
                    point: percent(x.point)
                };
            })
        };
        return payload;
    }

    const handleSaveDraft = () => {
        const payload = handleMapPayloadSaveDraft();
        dispatch(saveDraft(payload)).then(res => {
            if (res && res.payload) {
                setDocumentId((res.payload as any)?.data)
            }
        })
    }

    const handleOpenModalConfirmComplete = () => {
        const payload = handleMapPayloadSaveDraft();
        dispatch(saveDraft(payload)).then(res => {
            if (res && res.payload) {
                if (currentStatusProcess?.isEvaluation)
                    handleOpenModalEvaConfirmComplete()
                else
                    handleOpenModalCheckConfirmComplete()
            }
        })
    }

    const handleOpenModalCheckConfirmComplete = () => {
        setOpenModalCheckConfirmComplete(true);
    }

    const handleCloseModalCheckConfirmComplete = (isReload = false) => {
        setOpenModalCheckConfirmComplete(false);
        if (isReload) {
            handleClose(isReload)
        }
    }

    const handleOpenModalEvaConfirmComplete = () => {
        setOpenModalEvaConfirmComplete(true);
    }

    const handleCloseModalEvaConfirmComplete = (isReload = false) => {
        setOpenModalEvaConfirmComplete(false);
        if (isReload) {
            handleClose(isReload)
        }
    }

    const handleOpenModalOtherComment = () => {
        setOpenModalOtherComment(true);
    }

    const handleCloseModalOtherGeneralComment = () => {
        setOpenModalOtherComment(false);
    }

    const handleGetOtherComments = (value) => {
        setLoadingComment(true);
        handleOpenModalOtherComment()
        dispatch(getOtherComment({ itemId: value, ownerId: accountTableId, planPeriodId: planPeriodId })).finally(() => { setLoadingComment(false) });
    }

    const handleOpenModalKrYear = (dataKr = null) => {
        if (dataKr) {
            dispatch(setFilterOrgCheckIn({ ...filters, reportScheduleId: dataKr?.reportScheduleId }));
            setKrBaseSelected({ id: dataKr.itemId })
        }
        setOpenModalReportKrYear(true);
    };

    const handleCloseModalKrYear = () => {
        setOpenModalReportKrYear(false);
        setKrBaseSelected(null)
    };

    const handleRowClick = (event, record) => {
        event.preventDefault();
        if (record?.itemId && _.startsWith(record?.itemCode, KeyResultSymbol)) {
            handleOpenModalKrYear(record)
        }
    };

    return (
        <Modal open={isOpen} maskClosable={false} confirmLoading={updating} footer={null} onCancel={handleClose} width={'80vw'} className='view'>
            <div className="d-flex gap-5">
                <Title level={3}>Đánh giá kết quả thực hiện mục tiêu - {accountableName}</Title>
            </div>
            <div className="table">
                <div className="header">
                    <Col md={8}>
                        <Row className='w-100'>
                            <Col md={4}><Input disabled size='large' className='w-100' value={currentPlanPeriod?.label} /></Col>
                            <Col md={1} />
                            <Col md={18}>
                                <Search size="large" allowClear placeholder="Nhập giá trị tìm kiếm" onSearch={handleFreeTextSearchQuery} enterButton />
                            </Col>
                        </Row>
                    </Col>
                    <Col md={13}>
                        <Row className='w-100 justify-content-end gap-2'>
                            {Object.keys(currentStatusProcess).length > 0 && !isFinished &&
                                <Button size="large" onClick={handleSaveDraft} disabled={updating} className="green">
                                    Lưu nháp
                                </Button>
                            }
                            {Object.keys(currentStatusProcess).length > 0 && !isFinished && (
                                <Button size="large" onClick={handleOpenModalConfirmComplete} disabled={updating} className="green">
                                    {`Xác nhận hoàn thành ${funcTypeToString(currentStatusProcess?.functionKey)}`}
                                </Button>
                            )

                            }
                            {/* <Button size="large" onClick={handleExport} disabled={updating} className="primary">
                                Xuất File
                            </Button> */}
                        </Row>
                    </Col>
                </div>
                <Table tableLayout='fixed' scroll={{ y: '60vh' }} loading={loading || updating} bordered
                    dataSource={
                        dataSource.map(x => ({
                            ...x,
                            key: x.itemId,
                            children: x.children?.map(y => ({ ...y, key: y.itemId }))
                        }))
                    }
                    expandable={{
                        expandedRowKeys,
                        onExpandedRowsChange(newExpandedRowKeys: any) {
                            setExpandedRowKeys(newExpandedRowKeys);
                        },
                    }}
                    rowClassName={(record, index) =>
                        _.startsWith(record.itemCode, ObjectiveSymbol) ? "fw-bold" : "" // Định nghĩa lớp CSS cho dòng lẻ
                    }
                    onRow={(record) => ({
                        onClick(event) {

                            const target = event.target as HTMLElement;
                            // Lấy danh sách tất cả các ô (td) trong hàng được nhấp
                            const cells = Array.from(event.currentTarget.querySelectorAll('td'));

                            // Xác định index của ô được nhấp
                            const clickedTd = target.closest('td'); // Tìm td gần nhất
                            if (!clickedTd) return; // Tránh lỗi nếu không tìm thấy td

                            const clickedIndex = cells.indexOf(clickedTd);

                            // Danh sách index của các cột cần loại trừ
                            const excludedIndexes = [8, 9, 10, 11]; // Ví dụ: loại trừ cột 0 (Name) và cột 1 (Age)

                            if (!excludedIndexes.includes(clickedIndex)) {
                                handleRowClick(event, record);
                            }
                        },
                    })}
                    pagination={false}
                    columns={Object.keys(currentStatusProcess).length > 0 ? columnConfig : columnsEvaluation}
                    summary={pageData => {
                        let totalContribution = 0;
                        let totalSelfEvaluate = 0;
                        let totalEvaluate = 0;

                        pageData.forEach(({ children, contribution, ratingPoint, point }) => {
                            totalContribution += contribution ?? 0;
                            totalSelfEvaluate += (ratingPoint * contribution)
                            totalEvaluate += (point * contribution);
                        });
                        return (
                            <Table.Summary fixed={'top'}>
                                <Table.Summary.Row className="fw-bold">
                                    <Table.Summary.Cell index={0}>
                                        Tổng cộng
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell index={1} />
                                    <Table.Summary.Cell align='center' index={2}>
                                        <span>{`${formatPoint(totalContribution)}%`}</span>
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell colSpan={3} index={3} />
                                    <Table.Summary.Cell align='center' index={4}>
                                        <span>{`${formatPoint(totalSelfEvaluate / totalContribution)}%`}</span>
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell colSpan={2} index={5} />
                                    <Table.Summary.Cell align='center' index={6}>
                                        {currentStatusProcess && (currentStatusProcess.functionKey !== FuncTypes.Check && currentStatusProcess.functionKey !== FuncTypes.Appraisal) &&
                                            <span>{`${formatPoint(totalEvaluate / totalContribution)}%`}</span>
                                        }
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell colSpan={3} index={6} />
                                </Table.Summary.Row>
                            </Table.Summary>
                        );
                    }}
                />
            </div>
            {isOpenModalEvaConfirmComplete &&
                <EvaConfirmCompleteEvaluation
                    accountTableName={accountableName}
                    accountTableId={accountTableId}
                    onClose={handleCloseModalEvaConfirmComplete}
                    isOpen={isOpenModalEvaConfirmComplete} />
            }
            {isOpenModalCheckConfirmComplete &&
                <CheckConfirmCompleteEvaluation
                    accountTableName={accountableName}
                    accountTableId={accountTableId}
                    functionType={currentStatusProcess?.functionKey}
                    onClose={handleCloseModalCheckConfirmComplete}
                    isOpen={isOpenModalCheckConfirmComplete} />
            }
            {isOpenModalReportKrYear &&
                <ReportYear isOpen={isOpenModalReportKrYear} isReadOnly={true} onClose={handleCloseModalKrYear} krSelected={krBaseSelected} />
            }
            {isOpenModalOtherComment && <OtherCommentComponent isLoading={isLoadingComment}
                data={otherComment} isOpen={isOpenModalOtherComment}
                onClose={handleCloseModalOtherGeneralComment} />}
        </Modal>
    );
};

export default EvaluationObjectiveKRComponent;
